import React from "react";
import Input from "../../components/input/input";
import Btn from "../../components/button/btnWithoutIcon";
import { colors } from "../../assets/config/color";
import { toast } from "react-toastify";
import LogoLogin from "../../assets/logos/log.jpg";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthServices";
function RegisterUser(props) {
  const [userData, setUserData] = React.useState({
    username: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const resetForm = () => {
    setUserData({
      username: "",
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
    });
  };
  const usernameChange = (event) => {
    setUserData({ ...userData, username: event.target.value });
  };
  const emailChange = (event) => {
    setUserData({ ...userData, email: event.target.value });
  };
  const passwordChange = (event) => {
    setUserData({ ...userData, password: event.target.value });
  };
  const confirmPasswordChange = (event) => {
    setUserData({ ...userData, confirmPassword: event.target.value });
  };
  const firstNameChange = (event) => {
    setUserData({ ...userData, firstName: event.target.value });
  };
  const lastNameChange = (event) => {
    setUserData({ ...userData, lastName: event.target.value });
  };

  const handleRegister = async () => {
   
    try {
      if (userData.firstName.trim() === "") {
        toast.error("Please enter your first name.");
        return;
      }
      if (userData.lastName.trim() === "") {
        toast.error("Please enter your last name.");
        return;
      }
      if (userData.username.trim() === "") {
        toast.error("Username is required");
        return;
      }
      if (userData.email.trim() === "") {
        toast.error("Email address is required.");
        return;
      }
      if (userData.password.trim() === "") {
        toast.error("Password is required");
        return;
      }
      if (userData.password !== userData.confirmPassword) {
        toast.error("Passwords do not match. Please try again.");
        return;
      }
      const Regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
      if (!userData.email.match(Regex)) {
        toast.error("Invalid email address. Please enter a valid email.");

        return;
      }
      setIsloading(true);
      const response = await AuthService.addEmployer(
        userData.username,
        userData.password,
        userData.email,
        7,
        userData.firstName,
        userData.lastName
      );
      if (response.message) {
        toast.success(response.message);
        resetForm();
        setIsloading(false);
        // handleNavigation("/login");
      } else {
        toast.error(response.error);
        setIsloading(false);
      }
    } catch (error) {
      toast.error("Oops! Something went wrong during registration.");
    }
  };

  const [isloading, setIsloading] = React.useState(false);
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="containerRe">
      <form>
        <img src={LogoLogin} alt="" width={150} height={100} />

        <div className="rowM">
          <h3 style={{ color: colors.gold }}>Register</h3>
        </div>
        <div className="row">
          <div className="input-wrapper">
            <label className="label" style={{ color: "black" }}>
              FirstName
            </label>
            <Input
              placeholder={"Fatoumata"}
              onChange={firstNameChange}
              type="text"
              value={userData.firstName}
            />
          </div>

          <div className="input-wrapper">
            <label className="label" style={{ color: "black" }}>
              LastName
            </label>
            <Input
              placeholder={"Diallo"}
              onChange={lastNameChange}
              type="text"
              value={userData.lastName}
            />
          </div>
        </div>

        <div className="row">
          <div className="input-wrapper">
            <label className="label" style={{ color: "black" }}>
              Username
            </label>
            <Input
              placeholder={"Fatma"}
              onChange={usernameChange}
              type="text"
              value={userData.username}
            />
          </div>

          <div className="input-wrapper">
            <label className="label" style={{ color: "black" }}>
              Email
            </label>
            <Input
              placeholder={"adresse@mail.com"}
              onChange={emailChange}
              type="text"
              value={userData.email}
            />
          </div>
        </div>

        <div className="row">
          <div className="input-wrapper">
            <label className="label" style={{ color: "black" }}>
              Password
            </label>
            <Input
              placeholder={"********"}
              onChange={passwordChange}
              type="password"
              value={userData.password}
            />
          </div>

          <div className="input-wrapper">
            <label className="label" style={{ color: "black" }}>
              Confirm Password
            </label>
            <Input
              placeholder={"********"}
              onChange={confirmPasswordChange}
              type="password"
              value={userData.confirmPassword}
            />
          </div>
        </div>

        <Btn
          txtbtn={isloading ? "Loading ..." : "Register"}
          bgcolor={"168, 102, 127"}
          bgopacity={isloading ? 0.5 : 1}
          txtcolor={"#fff"}
          action={handleRegister}
        />

        <div className="rowEnd" style={{ marginTop: "12px" }}>
          <span style={{ cursor: "default" }}>Already have an account?</span>
          <span
            style={{ color: "#09AA29", textDecoration: "underline" }}
            onClick={() => handleNavigation("/")}
          >
            login
          </span>
        </div>
      </form>
    </div>
  );
}

export default RegisterUser;
